import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeString',
  standalone: false,
})
export class DecodeStringPipe implements PipeTransform {
  transform(encodedString: string): string {
    /* eslint-disable */
    return encodedString?.replace(/[^\x00-\x7F]/g, ' ');
  }
}
